import e from'@mui/material/Menu';var r=e;export{r as Menu};//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map